import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex mb-2 mx-8 sm:px-0"
}
const _hoisted_2 = { class: "-mt-px flex w-0 flex-1" }
const _hoisted_3 = { class: "hidden md:-mt-px md:flex" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "-mt-px flex w-0 flex-1 justify-end" }

import {computed, PropType, ref} from 'vue';
import {UserSearchDto} from "@/areas/users/dtos/userSearchDto";
import {DonationSearchDto} from "@/areas/users/dtos/donationSearchDto";
import {SearchDto} from "@/areas/helpers/searchDto";


export default /*#__PURE__*/_defineComponent({
  __name: 'PaginationV2',
  props: {
  searchDto: {
    type: Object as PropType<SearchDto | UserSearchDto | DonationSearchDto>,
    required: true,
  },
},
  emits: ['change', 'update:selected'],
  setup(__props, { emit: __emit }) {

const props = __props

const emits = __emit

const searchDto = ref(props.searchDto)

const startPage = ref<number>(1)
const endPage = ref<number>(searchDto.value.totalPages ?? 1)

const goToPage = (page: number) => {
  if (!props.searchDto){
    return;
  }
  if (page > 0 && page <= searchDto.value!.totalPages!){
    emits('change', page)
  }
}

const displayedPages = computed(() => {
  if (searchDto.value.totalPages){
    if (searchDto.value.totalPages < 6){
      endPage.value = searchDto.value.totalPages
    } else {
      endPage.value = 5
    }
    
    if (searchDto.value.pageNumber < 3){
      startPage.value = 1
    }
    
    if (searchDto.value.totalPages - searchDto.value.pageNumber < 2){
      endPage.value = searchDto.value.totalPages
    }
    //
    if (searchDto.value.pageNumber >= 3 && searchDto.value.pageNumber+2 <= searchDto.value.totalPages){
      startPage.value = searchDto.value.pageNumber - 2
      endPage.value = searchDto.value.pageNumber + 2
    }
    
    return Array.from({length: endPage.value - startPage.value + 1}, (_, i) => startPage.value + i);
  }
});

return (_ctx: any,_cache: any) => {
  return (searchDto.value)
    ? (_openBlock(), _createElementBlock("nav", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("a", {
            href: "#",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (goToPage(props.searchDto.pageNumber-1))),
            class: "inline-flex items-center border-t-2 border-transparent pr-1 pt-4 text-sm font-medium text-gray-500 hover:text-gray-700"
          }, " Previous ")
        ]),
        _withDirectives(_createElementVNode("a", {
          class: "inline-flex items-center px-4 pt-4 text-sm font-medium text-dark-blue",
          "aria-current": "page"
        }, _toDisplayString('...'), 513), [
          [_vShow, startPage.value > 1]
        ]),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayedPages.value, (pageNumber) => {
            return (_openBlock(), _createElementBlock("a", {
              key: pageNumber,
              onClick: ($event: any) => (goToPage(pageNumber)),
              class: _normalizeClass([{ 'border-b-2 border-dark-blue': props.searchDto.pageNumber === pageNumber }, "inline-flex items-center px-4 pt-4 text-sm font-medium text-dark-blue cursor-pointer"]),
              "aria-current": "page"
            }, _toDisplayString(pageNumber), 11, _hoisted_4))
          }), 128))
        ]),
        _withDirectives(_createElementVNode("a", {
          class: "inline-flex items-center px-4 pt-4 text-sm font-medium text-dark-blue",
          "aria-current": "page"
        }, _toDisplayString('...'), 513), [
          [_vShow, searchDto.value.totalPages && endPage.value < searchDto.value.totalPages]
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("a", {
            href: "#",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (goToPage(props.searchDto.pageNumber+1))),
            class: "inline-flex items-center border-t-2 border-transparent pl-1 pt-4 text-sm font-medium text-gray-500 hover:text-gray-800"
          }, " Next ")
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})